// Registry of the product pages built with the shared template (VAT Returns, VAT Groups, and so on).
// SAF-T and e-Invoicing have their own older pages and are not listed here.
// This file is generated: to add a product, a new config file and a new details file are added and the two lists below grow.
import ecSalesList from './ec-sales-list';
import ecompliance from './ecompliance';
import intrastat from './intrastat';
import taxFinanceOperations from './tax-finance-operations';
import vatGroups from './vat-groups';
import vatReturns from './vat-returns';
const SOLUTIONS = {
  "ec-sales-list": ecSalesList,
  "ecompliance": ecompliance,
  "intrastat": intrastat,
  "tax-finance-operations": taxFinanceOperations,
  "vat-groups": vatGroups,
  "vat-returns": vatReturns,
};
const DETAIL_LOADERS = {
  "ec-sales-list": () => import('./ec-sales-list-countries'),
  "intrastat": () => import('./intrastat-countries'),
  "vat-groups": () => import('./vat-groups-countries'),
  "vat-returns": () => import('./vat-returns-countries'),
};
export const fill = (text, vars) =>
  String(text || '').replace(/\{(\w+)\}/g, (m, k) => (vars && vars[k] !== undefined && vars[k] !== null ? vars[k] : ''));
export const getSolution = (slug) => SOLUTIONS[slug] || null;
export const solutionList = () => Object.values(SOLUTIONS);
export const solutionCountries = (slug) => {
  const s = SOLUTIONS[slug];
  return s && Array.isArray(s.countries) ? s.countries : [];
};
export const getSolutionCountry = (slug, countrySlug) => solutionCountries(slug).find((c) => c.slug === countrySlug) || null;
// Full content of one country page. Loaded on demand, so the country texts never weigh down other pages.
export const loadCountryDetail = async (slug, countrySlug) => {
  const loader = DETAIL_LOADERS[slug];
  if (!loader) return null;
  const mod = await loader();
  return (mod.COUNTRY_DETAILS && mod.COUNTRY_DETAILS[countrySlug]) || null;
};
export const solutionPath = (slug) => `/solutions/${slug}`;
// Entries for the Solutions menu and the footer: only products whose config says menu.show is true.
export const solutionMenuItems = () =>
  solutionList()
    .filter((s) => s.menu && s.menu.show)
    .map((s) => ({ href: solutionPath(s.slug), label: s.menu.label || s.name, desc: s.menu.desc || '' }));
// Page title and description for the browser tab and search results.
// Returns null if the path is not one of these product pages.
export const getSolutionMeta = (rawPath) => {
  const parts = String(rawPath || '').split(/[?#]/)[0].replace(/\/+$/, '').split('/').filter(Boolean);
  if (parts[0] !== 'solutions' || parts.length < 2 || parts.length > 3) return null;
  const s = SOLUTIONS[parts[1]];
  if (!s) return null;
  if (parts.length === 2) return { title: s.meta.title, description: s.meta.description };
  const c = getSolutionCountry(parts[1], parts[2]);
  return c ? { title: c.title, description: c.description } : null;
};
